<template>
  <div class="schedule-override-management">
    <!-- 页面头部 -->
    <div class="page-header">
      <el-page-header @back="goBack" :content="`${technicianName} - 临时排班管理`"></el-page-header>
    </div>

    <!-- 操作区域 -->
    <div class="operation-area" style="margin: 20px 0;">
      <el-button type="primary" @click="handleAdd" v-auth="'/technician/scheduleOverride/add'" size="small">
        <i class="el-icon-plus"></i> 添加临时排班
      </el-button>
    </div>

    <!-- 临时排班列表 -->
    <div class="table-wrap">
      <el-table :data="tableData" style="width: 100%" v-loading="loading">
        <el-table-column prop="schedule_date" label="排班日期" width="120"></el-table-column>
        <el-table-column label="工作时间" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.start_time && scope.row.end_time">
              {{ scope.row.start_time.substring(0,5) }} - {{ scope.row.end_time.substring(0,5) }}
            </div>
            <div v-else class="no-time">未设置</div>
          </template>
        </el-table-column>
        <el-table-column label="休息时间" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.break_start_time && scope.row.break_end_time">
              {{ scope.row.break_start_time.substring(0,5) }} - {{ scope.row.break_end_time.substring(0,5) }}
            </div>
            <div v-else class="no-time">无休息时间</div>
          </template>
        </el-table-column>
        <el-table-column prop="note" label="备注" show-overflow-tooltip></el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="text" size="small" v-auth="'/technician/scheduleOverride/edit'">编辑</el-button>
            <el-button @click="handleDelete(scope.row)" type="text" size="small" style="color: #f56c6c;" v-auth="'/technician/scheduleOverride/delete'">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                     :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
                     :total="totalDataNumber">
      </el-pagination>
    </div>

    <!-- 添加临时排班弹窗 -->
    <Add v-if="openAdd" :open_add="openAdd" :technician="technicianInfo" @closeDialog="closeDialog"></Add>

    <!-- 编辑临时排班弹窗 -->
    <Edit v-if="openEdit" :open_edit="openEdit" :schedule_data="currentSchedule" @closeDialog="closeDialog"></Edit>
  </div>
</template>

<script>
import ScheduleOverrideApi from '@/api/technician/scheduleOverride.js';
import Add from './Add.vue';
import Edit from './Edit.vue';

export default {
  name: 'ScheduleOverrideManagement',
  components: {
    Add,
    Edit
  },
  data() {
    return {
      loading: true,
      tableData: [],
      pageSize: 10,
      totalDataNumber: 0,
      curPage: 1,
      technicianId: 0,
      technicianName: '',
      technicianInfo: {},
      openAdd: false,
      openEdit: false,
      currentSchedule: {}
    };
  },
  created() {
    // 从路由参数获取技师信息
    this.technicianId = this.$route.query.technician_id;
    this.technicianName = this.$route.query.technician_name || '未知技师';
    this.technicianInfo = {
      id: this.technicianId,
      name: this.technicianName
    };

    if (this.technicianId) {
      this.getData();
    } else {
      this.$message.error('缺少技师信息');
      this.goBack();
    }
  },
  methods: {
    /**
     * 获取临时排班列表数据
     */
    getData() {
      let self = this;
      let params = {
        technician_id: self.technicianId,
        page: self.curPage,
        list_rows: self.pageSize
      };
      self.loading = true;
      ScheduleOverrideApi.getList(params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /**
     * 返回上一页
     */
    goBack() {
      this.$router.go(-1);
    },
    /**
     * 添加临时排班
     */
    handleAdd() {
      this.openAdd = true;
    },
    /**
     * 编辑临时排班
     */
    handleEdit(row) {
      this.currentSchedule = { ...row };
      this.openEdit = true;
    },
    /**
     * 删除临时排班
     */
    handleDelete(row) {
      this.$confirm('确认删除这条临时排班记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ScheduleOverrideApi.del({ id: row.id }, true)
          .then(res => {
            if (res.code === 1) {
              this.$message.success('删除成功');
              this.getData();
            }
          })
          .catch(error => {
            // 错误已在request中处理
          });
      }).catch(() => {
        // 用户取消删除
      });
    },
    /**
     * 关闭弹窗
     */
    closeDialog(e) {
      this.openAdd = false;
      this.openEdit = false;
      this.currentSchedule = {};

      // 如果操作成功，刷新列表
      if (e && e.type === 'success') {
        this.getData();
      }
    },
    /**
     * 每页条数改变
     */
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },
    /**
     * 当前页改变
     */
    handleCurrentChange(val) {
      this.curPage = val;
      this.getData();
    }
  }
};
</script>

<style scoped>
.schedule-override-management {
  /*padding: 20px;*/
}

.page-header {
  margin-bottom: 20px;
}

.operation-area {
  margin: 20px 0;
}

.table-wrap {
  /*background: #fff;*/
  /*padding: 20px;*/
  /*border-radius: 4px;*/
  /*box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);*/
}

.no-time {
  color: #909399;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/scheduleoverride/index.vue